import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pasT",
  "use": "icon-pasT-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"icon-pasT\"><defs><style>#icon-pasT .cls-1,#icon-pasT .cls-2{fill:#005faf;}#icon-pasT .cls-2{fill-rule:evenodd;}</style></defs><title>lock</title><g id=\"icon-pasT_未标题-1.psd\"><g id=\"icon-pasT__-s-lock_icon\" data-name=\"-s-lock icon\"><path class=\"cls-1\" d=\"M324,145H294a93,93,0,0,0-186,0H78a123,123,0,0,1,246,0Z\" /><path class=\"cls-1\" d=\"M306,382H96a75.09,75.09,0,0,1-75-75V217a75.09,75.09,0,0,1,75-75H306a75.09,75.09,0,0,1,75,75v90A75.09,75.09,0,0,1,306,382ZM96,172a45.05,45.05,0,0,0-45,45v90a45.05,45.05,0,0,0,45,45H306a45.05,45.05,0,0,0,45-45V217a45.05,45.05,0,0,0-45-45Z\" /><path class=\"cls-2\" d=\"M239.91,217H162.09a15,15,0,0,0-15,15v6.09a15,15,0,0,0,15,15h21.1V307a17.81,17.81,0,0,0,35.62,0V253.09h21.1a15,15,0,0,0,15-15V232A15,15,0,0,0,239.91,217Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pasT.svg
// module id = iIck
// module chunks = 35